import { __assign } from "tslib";
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { debounce } from '@mui/material/utils';
import { CUSTOMER_PROFILE_FILTERS, CUSTOMER_SECTION_FORM } from 'models/constants';
import Lead from 'models/Lead';
import { getSectionForm } from 'utils';
import useCustomSectionForm from './useCustomSectionForm';
var inputFocusTimeout;
var GUID_REGEXP = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
var addressParams = CUSTOMER_SECTION_FORM.address, basicParams = CUSTOMER_SECTION_FORM.basic, fieldsParams = CUSTOMER_SECTION_FORM.fields, phonesParams = CUSTOMER_SECTION_FORM.phones;
var defaultPhones = new Lead().person.phones;
var useCustomerProfile = function (_a) {
    var hasFilter = _a.hasFilter, lmktId = _a.lmktId, getCustomerData = _a.getCustomerData, onFilter = _a.onFilter;
    var _b = useFormContext(), getFieldState = _b.getFieldState, reset = _b.reset, watch = _b.watch;
    var _c = useState([]), sections = _c[0], setSections = _c[1];
    var getCustomFieldsSection = useCustomSectionForm(fieldsParams, hasFilter, setSections).getCustomSection;
    var getCustomPhonesSection = useCustomSectionForm(phonesParams, hasFilter, setSections).getCustomSection;
    var debounceFilter = debounce(function (customer, inputName) {
        var fromInvalidDOB = inputName === 'person.dateOfBirth' &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getFieldState(inputName).error;
        if (!fromInvalidDOB) {
            onFilter(customer);
            if (inputName) {
                clearTimeout(inputFocusTimeout);
                inputFocusTimeout = setTimeout(function () {
                    var input = document.querySelector("[name=\"".concat(inputName, "\"]"));
                    input.focus();
                });
            }
        }
    }, 550);
    useEffect(function () {
        setSections(function () { return [
            getSectionForm(basicParams, hasFilter),
            getCustomPhonesSection(defaultPhones),
            getSectionForm(addressParams, hasFilter)
        ]; });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (GUID_REGEXP.test(lmktId)) {
            getCustomerData({
                variables: {
                    whereLead: {
                        isLocked: { eq: false },
                        id: {
                            eq: lmktId
                        }
                    }
                }
            }).then(function (_a) {
                var leadData = _a.data;
                if (leadData === null || leadData === void 0 ? void 0 : leadData.leads) {
                    var newLead = new Lead(leadData.leads.nodes[0]);
                    var fields = newLead.fields, phones = newLead.person.phones;
                    var newPhonesSection_1 = getCustomPhonesSection(phones);
                    var newFieldsSection_1 = getCustomFieldsSection(fields);
                    setSections(function (_a) {
                        var basicSection = _a[0], addressSection = _a[2];
                        return [
                            basicSection,
                            newPhonesSection_1,
                            addressSection,
                            newFieldsSection_1
                        ];
                    });
                    reset(newLead);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lmktId,
        getCustomerData,
        getCustomFieldsSection,
        getCustomPhonesSection,
        reset
    ]);
    useEffect(function () {
        var watchSubscription = watch(function (_a, _b) {
            var person = _a.person;
            var name = _b.name, type = _b.type;
            if (type &&
                hasFilter &&
                (!name || CUSTOMER_PROFILE_FILTERS.includes(name)))
                debounceFilter(__assign({}, person), name);
        });
        return function () {
            watchSubscription.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasFilter]);
    return { sections: sections };
};
export default useCustomerProfile;
//# sourceMappingURL=useCustomerProfile.js.map